import firebase from 'firebase/app'
import 'firebase/auth';
import auth from '@/store/modules/auth/auth'

export const getLoginStatus = function (){
  //
  return new Promise((res)=>{
    firebase
      .auth()
      .onAuthStateChanged((user) => {
        if (user) {
          //
          auth.state.isLoggedIn = true
          auth.state.user = user
          //
          //
        } else {
          //
          auth.state.isLoggedIn = false
          auth.state.user = {}
          //
        }
        //
        res({
          user: auth.state.user,
          isLoggedIn: auth.state.isLoggedIn
        }) // return login status
        auth.state.authLoader = false
      })
  })
}



// WEBPACK FOOTER //
// ./src/helper/auth.js